<template>
    <notification-list
        :notifications="$store.state.notifications.slice().reverse()"
        full-text
    />
</template>

<script>
    import NotificationList from "@/components/NotificationList";
    export default {
        name: "AllNotifications",
        components: {NotificationList}
    }
</script>

<style scoped>

</style>